import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/my-clans/$tag/search-filters/personal")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/my-clans/$tag/player-search/filters",
      params,
    });
  },
});
